import Prototyping from './Template'

export default Prototyping
